import { XStack, YStack } from '@/components/ui';
import { classList } from '@/utils/cn';

type MessageQuotesProps = {
  quotes: string[];
  className?: string;
};

export const MessageQuotes = ({ quotes, className }: MessageQuotesProps) => (
  <XStack className={classList('items-stretch gap-4 py-1', className)}>
    <span className="w-1 shrink-0 bg-border-strongest rounded-full" />
    <YStack className="flex-1 gap-1">
      {quotes.map((quote, index) => (
        <span key={index} className="text-base text-foreground leading-relaxed">
          {quote}
        </span>
      ))}
    </YStack>
  </XStack>
);
